<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <PageTitle />
        <b-card v-if="!loading">
          <b-row>
            <b-col sm="12">
              <b-form-group>
                <label for="consentModel">{{ $t('informedConsent.consentModels') }}
                  <required-field/>
                </label>
                <v-select id="consentModel" v-model="informedConsent.consentModel" :getOptionLabel="getParsedModels" :options="models"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="region">{{ $t('informedConsent.regionLabel') }}
                  <required-field/>
                </label>
                <v-select id="region" v-model="informedConsent.region" :options="regions"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <label for="informationModel">{{ $t('informedConsent.informationModels') }}
                  <required-field/>
                </label>
                <v-select id="informationModel" v-model="informedConsent.informationModel" :getOptionLabel="getParsedModels" :options="models"></v-select>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <button class="btn btn-success float-right padder" type="button" @click="createInformedConsent">
                {{ $t('actions.save') }}
              </button>
              <router-link class="btn btn-primary float-right" role="button" :to="{name: 'informationConsentsListRoute'}" push>
                {{ $t('actions.abort') }}
              </router-link>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import miniToastr from "mini-toastr";
import PageTitle from "../../components/PageTitle";
import i18n from '@/config/i18n'
import moment from "moment";
import InformationConsentService from "../../services/InformationConsentService";
import RequiredField from "../../components/RequiredField";
import vSelect from "vue-select";
const informationConsentService = InformationConsentService.build();
import ModelService from "@/services/ModelService";
import RegionService from "@/services/RegionService";
const modelService = ModelService.build();
const regionService = RegionService.build();

export default {
  name: "InformedConsentNew",
  components: {
    PageTitle,
    RequiredField,
    vSelect,
  },
  data() {
    return {
      informedConsent: {
        validityStartDate: new Date(),
        consentModel: null,
        region: { code: "05", label: "Veneto" },
        informationModel: null
      },
      loading: true,
      models: [],
      regions: []
    }
  },
  created() {
    miniToastr.init();
    miniToastr.setIcon('info', 'i', {'class': 'fas fa-info-circle'});
    this.loading = true
    this.getModels()
    this.getRegions()
    this.loading = false
  },
  methods: {
    status (status = 'unknown') {
      return i18n.t(`pendingConsent.status.${status}`)
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    getParsedModels(model) {
      return `${model.description} (ID: ${model.code})`
    },
    async getModels() {
      this.models = (await modelService.search({ max: -1 })).data;
    },
    async getRegions() {
      this.regions = (await regionService.search({ max: -1 })).regions;
    },
    async createInformedConsent() {
      try {
        await informationConsentService.create(
          {
            regionCode: this.informedConsent.region.code ? this.informedConsent.region.code : '',
            consentModelCode: this.informedConsent.consentModel? this.informedConsent.consentModel.code : '',
            informationModelCode: this.informedConsent.informationModel ? this.informedConsent.informationModel.code : '',
          })
        this.$router.push({name: 'informationConsentsListRoute'})
        miniToastr.info("Consenso informato creato con successo");
      } catch (exception) {
        if (exception.errors){
          this.errors = exception.errors
        exception.errors.forEach(function (element) {
          miniToastr.error(element.message);
        });
      }else{
          this.errors = exception.message
          miniToastr.error(this.errors);
        }
      }
    }
  }
}
</script>
